import CreatorDecryptPage from "./CreatorDecryptPage";

export default CreatorDecryptPage;
